const ShelterList = () => import('Views/shelter/shelter-list');
const ShelterAddEdit = () => import('Views/shelter/shelter-addEdit');
const ShelterDetail = () => import('Views/shelter/shelter-detail');

export default[
  { path: '/shelter-list', component: ShelterList },
  { path: '/shelter-add', component: ShelterAddEdit },
  { path: '/shelter-edit/:id', component: ShelterAddEdit },
  { path: '/shelter-detail/:id', component: ShelterDetail },
];



// WEBPACK FOOTER //
// ./src/router/shelter.js